import styled from "styled-components";
export const SIZES = {
    MIN_NAME_WIDTH: 140,
    MAX_NAME_WIDTH: 240,
    AVATAR_SIZE: 24
};
export default {
    Name: styled.div.attrs({ className: "ml-xxs d-flex" }) `
    min-width: ${SIZES.MIN_NAME_WIDTH}px;
    max-width: ${SIZES.MAX_NAME_WIDTH}px;
  `,
    EmptyAvatar: styled.div `
    width: ${SIZES.AVATAR_SIZE}px;
    height: ${SIZES.AVATAR_SIZE}px;
  `
};
